/// <summary>
/// This object provides client-side functions for 
/// <br/>
/// Author: GWA<br />
/// Date: 2.7.2019<br />
/// Copyright ©: EUDT GmbH 2019 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.1.0 - 16.10.2019                                              *<br />
/// **********************************************************************<br />
/// * - Feature for using holidays included                              *<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 2.7.2019                                                *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
$.widget("bluaul.vcCalendarFilter",
    {
        myClassVariable: null,
        options: {
            parameter: null,
            langID: 2, 
            type: "embedded",
            width: 596,
            height: 485,
            align: "right",
            data: {
                "Months": [],
                "WeekDays": [],
                "Timer": "111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111",
                "FromTo": [
                    /*    {
                            range: ["3.7.2019", "24.7.2019"],
                            description: "test"
                        }*/
                ],
                "Holidays": false
            },
            callback: function () { }
            //settings object of the current instance

        },

        data: {
            "ID": "",
            "AID": "",
            "Months": [],
            "WeekDays": [],
            "Timer": "",
            "FromTo": [],
            "Holidays": false
        },

        lang: "",

        resources: window.__CalendarFilterResources,

        _create: function () {
            //add the filter class to the given div
            if (this.element.hasClass("vc-calendar-filter") === false) {
                this.element.addClass("vc-calendar-filter");
            }
            this.element.addClass("vc-grid-3col");

            this._setGlobals();

            var html = null;

            var container = $("<div>").addClass("container");
            var navigation = $("<div>").addClass("navigation");
            var content = $("<div>").addClass("content");
            var firstPage = $("<div>").addClass("first-page page");
            var period = $("<div>").addClass("period");
            var calendarSequence = $("<div>").addClass("calendar-sequence");
            var secondPage = $("<div>").addClass("second-page page");

            container.append(
                navigation.append(
                    this._getButtonNavigation("first-page", true),
                    this._getButtonNavigation("second-page", false)
                ),
                content.append(
                    firstPage.append(
                        period.append(
                            calendarSequence.append(
                                this._getMonth(),
                                this._getWeek()
                            ),
                            this._getTime()
                        )
                    ),
                    secondPage.append(
                        this._getFromTo()
                    )
                )
            );


            if (this.options.type === "popup") {
                var popup = $("<div>").addClass("popup");
                var btnPopup = $("<div>").addClass("popup-switch");

                btnPopup.html(this.resources[this.lang].calendar);
                btnPopup.button();

                //container.append(
                //    footer.append(
                //        confirm.html(this.resources[this.lang].button.save).button()
                //    )
                //);

                html = popup.append(btnPopup, container.hide());
            } else {
                html = container;
            }

            this.element.append(html);

            this._setOptions();

            this._initInput();

            return this;
        },

        //create the input field and add the change event handlers
        _initInput: function () {
            var me = this;

            if (this.options.type === "popup")
                this.element.on("click",
                    ".popup-switch",
                    function () {
                        var thisContainer = me.element.find(".container");

                        if (thisContainer.is(":hidden")) {
                            thisContainer.css("z-index", me._getHighestZIndex() + 1);
                            thisContainer.show();
                        } else {
                            thisContainer.hide();
                            thisContainer.css("z-index", "auto");
                        }
                    });

            this.element.on("click",
                ".from-to-add",
                function () {
                    me._openFromToPopup(false);
                });

            this.element.on("click",
                ".from-to-content .from-to-list-item .from-to-list-item-delete",
                function () {
                    $(this).closest("div.from-to-list-item").remove();
                    me.options.callback();
                });

            this.element.on("mouseenter mouseleave",
                ".from-to i",
                function () {
                    $(this).removeClass("color-font-primary");
                });

            this.element.on("click",
                ".navigation div",
                function () {
                    me.element.find("div.page").hide();
                    me.element.find("div.page." + $(this).data("page")).show();

                    me.element.find(".navigation > div").removeClass("button-toggle-active");

                    $(this).addClass("button-toggle-active");
                });

            this.element.on("change",
                ".check-all input[type='checkbox']",
                function () {
                    var target = $(this).data("checkboxes");

                    var checkboxes = me.element.find("." + target + " .checkbox");

                    if ($(this).prop("checked")) checkboxes.prop("checked", true);
                    else checkboxes.prop("checked", false);
                });

            this.element.on("click",
                ".from-to-content .from-to-list-item .from-to-list-item-edit",
                function () {
                    var item = $(this).closest(".from-to-list-item");
                    item.data("edit", true);

                    var itemData = item.find("p.range").html().split(" - ");

                    var data = {
                        from: itemData[0],
                        to: itemData[1]
                    };

                    var itemDescription = item.find(".from-to-list-item-description").html();

                    me._openFromToPopup(true, data, itemDescription);
                });
            this.element.on("click",
                ".checkbox-holiday",
                function () {
                    me._fillHolidayContent();
            });
            
            this.element.find("input, .time .clocktimer div.cl.cl1").on("click", this.options.callback);
        },

        _destroy: function () {
            this.element
                .removeClass("vc-calendar-filter")
                .html("");
        },

        _getMonth: function () {
            // ReSharper disable once AssignedValueIsNeverUsed
            var input = null;
            var html = $("<div>").addClass("month vc-grid-2col");
            var header = $("<div>").addClass("header").html(this.resources[this.lang].label.months);
            var checkAll = $("<div>").addClass("check-all");

            checkAll.append(
                $("<input>").attr("id", this.element.attr("id") + "-check-month").prop("type", "checkbox").prop("value", "all").addClass("all").data("checkboxes", "month"),
                $("<label>").attr("for", this.element.attr("id") + "-check-month").html(this.resources[this.lang].label.checkAll)
            );

            var left = $("<div>").addClass("item vc-grid-1col");
            var right = $("<div>").addClass("item vc-grid-1col");

            for (var i = 0; i < 12; i++) {
                input = $("<div>").addClass("month-input"); //.addClass("day-month-month-checkbox");

                input.append(
                    $("<input>").prop("type", "checkbox").prop("value", this.resources["months"].long[i])
                        .addClass("checkbox")
                        .attr("id", this.element.attr("id") + "-month-" + this.resources["months"].short[i])
                );

                input.append(
                    $("<label>").html(this.resources["months"].long[i])
                        .attr("for", this.element.attr("id") + "-month-" + this.resources["months"].short[i])
                );

                if (i < 6) left.append(input);
                else right.append(input);
            }

            //html.append(header, checkAll, left, right);
            html.append(header.append(checkAll), left, right);
            return html;
        },

        _getWeek: function () {
            var input = null;
            var html = $("<div>").addClass("week vc-grid-2col");
            var item = $("<div>").addClass("item");
            var header = $("<div>").addClass("header").html(this.resources[this.lang].label.weekDays);

            //html.append(header);

            var checkAll = $("<div>").addClass("check-all");

            checkAll.append(
                $("<input>").attr("id", this.element.attr("id") + "-check-week").prop("type", "checkbox").prop("value", "all").addClass("all").data("checkboxes", "week"),
                $("<label>").attr("for", this.element.attr("id") + "-check-week").html(this.resources[this.lang].label.checkAll)
            );

            for (var i = 0; i < 7; i++) {
                input = $("<div>").addClass("week-input");

                input.append(
                    $("<input>").prop("type", "checkbox").prop("value", this.resources["weekDays"].long[i])
                        .addClass("checkbox")
                        .attr("id", this.element.attr("id") + "-week-" + this.resources["weekDays"].short[i]),
                    $("<label>").html(this.resources["weekDays"].long[i])
                        .attr("for", this.element.attr("id") + "-week-" + this.resources["weekDays"].short[i])
                );

                item.append(input);
            }
            //html.append(header, checkAll, item);
            html.append(header.append(checkAll), item);
            return html;
        },

        _getTime: function () {
            var timerContainer = $("<div>").addClass("time");
            var header = $("<div>").addClass("header").html(this.resources[this.lang].label.timer);
            var timer = $("<div>")
                .attr("id", this.data.ID + "_timer")
                .addClass("timer");

            timerContainer.append(header, timer);

            return timerContainer;
        },

        _getButtonNavigation: function (page, active) {
            var html = $("<div>").data("page", page);

            if (active) html.addClass("button-toggle-active");

            switch (page) {
                case "first-page":
                    html.html(this.resources[this.lang].button.firstPage);
                    break;
                case "second-page":
                    html.html(this.resources[this.lang].button.secondPage);
                    break;
                default:
            }

            return html.button();
        },

        _getFromTo: function () {

            var html = $("<div>").addClass("from-to vc-list");

            html.append(
                $("<div>").addClass("vc-list-header").append(
                    $("<div>").addClass("vc-list-item").append(
                        $("<input>").attr("type", "checkbox").addClass("checkbox-holiday"),
                        $("<p>").addClass("checkbox-holiday-label").text(this.resources[this.lang].label.holidays)
                    )
                ),
                $("<div>").addClass("vc-list-table holiday-content")
            );

            html.append(
                $("<div>").addClass("vc-list-header").append(
                    $("<div>").addClass("vc-list-item").append(
                        $("<div>").addClass("from-to-header vc-list-col-element w80").html(this.resources[this.lang].label.ignores),
                        $("<div>").addClass("vc-list-col-element w20").append(
                            $("<div>").addClass("from-to-add").html(this.resources[this.lang].button.fromToAdd).button()
                        )
                    )
                ),
                $("<div>").addClass("from-to-description").html(this.resources[this.lang].label.fromToList),
                $("<div>").addClass("from-to-content vc-list-table"),
                $("<div>").addClass("_temp")
            );

            return html;
        },

        _getFromToListItem: function (data, descriptionData) {
            var html = $("<div>").addClass("from-to-list-item vc-list-item");
            var el = $("<div>");
            var elData = "";

            var item = $("<div>").addClass("vc-list-col-element w80");

            var range = $("<div>").addClass("from-to-list-item-data vc-list-col-element");
            var description = $("<div>").addClass("from-to-list-item-description vc-list-col-element");

            if (typeof descriptionData !== 'undefined') description.html(descriptionData);

            var deleteItem = $("<div>").addClass("from-to-list-item-delete vc-list-col-element w10").append(
                $("<i>").addClass("icon-color-error fa fa-times fa-2x icon-nav")
            );

            var editItem = $("<div>").addClass("from-to-list-item-edit vc-list-col-element w10").append(
                $("<i>").addClass("fa fa-edit fa-2x icon-nav")
            );

            var rangeText = "";
            if (typeof data === "undefined") {

                el.vcDate({
                    mode: "Range",
                    align: "center",
                    interval: 1,
                    langID: this.langID,
                    callback: function () { }
                });

                elData = el.find("div.div-widget  ul.ul-menue  li.li-content.ul-menue-li  div.div-dropdown  div.div-dropdowntext.vertical p").html().split("<br>");

                rangeText = elData[0] + " - " + elData[1];
            } else if (typeof data.range[1] === "undefined" || data.range[1].length < 1 || data.range[1] === null) {
                if (data.range[0].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null) { //if data.from (data.range[0]) is a valid date (format not value)
                    rangeText = data.range[0];
                } else {
                    //Error
                }
            } else if (typeof data.range[1] !== "undefined" && data.range[1].length > 0 && data.range[1] !== null) { //if data.from (data.range[0]) AND data.to (data.range[1]) is a valid date (format not value)
                if (data.range[0].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null && data.range[1].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null) {
                    rangeText = data.range[0] + " - " + data.range[1];
                } else {
                    //Error
                }
            }
            if (typeof data.repeat !== "undefined") {
                if (data.repeat) {
                    rangeText += " " + "(" + this.resources[this.langID].label.holidayYearly + ")";
                }
            }
            range.append($("<p>").addClass("range").html(rangeText));
            item.append(range, description);

            html.append(editItem, item, deleteItem);

            return html;
        },
        _getHolidayListItem: function (data, descriptionData) {
            var html = $("<div>").addClass("holiday-list-item");
            var el = $("<div>");
            var elData = "";

            var item = $("<div>").addClass("holidays-list-item");
            var range = $("<div>").addClass("holiday-list-item-data");
            var description = $("<div>").addClass("holiday-list-item-description");

            if (typeof descriptionData !== 'undefined') description.html(descriptionData);

            var rangeText = "";
            if (typeof data === "undefined") {

                el.vcDate({
                    mode: "Range",
                    align: "center",
                    interval: 1,
                    langID: this.langID,
                    callback: function () { }
                });

                elData = el.find("div.div-widget  ul.ul-menue  li.li-content.ul-menue-li  div.div-dropdown  div.div-dropdowntext.vertical p").html().split("<br>");

                rangeText = elData[0] + " - " + elData[1];
            } else if (data.range[1] === null || typeof data.range[1] === "undefined" || data.range[1].length < 1) {
                if (data.range[0].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null) { //if data.from (data.range[0]) is a valid date (format not value)
                    rangeText = data.range[0];
                } else {
                    //Error
                }
            } else if (typeof data.range[1] !== "undefined" && data.range[1].length > 0 && data.range[1] !== null
            ) { //if data.from (data.range[0]) AND data.to (data.range[1]) is a valid date (format not value)
                if (data.range[0].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null &&
                    data.range[1].match("^[0-9]{1,2}\.{1}[0-9]{1,2}\.{1}([0-9]{4}|)$") !== null) {
                    rangeText = data.range[0] + " - " + data.range[1];
                } else {
                    //Error
                }
            } else {
                //parameters are extremely wrong
            }
            if (typeof data.repeat !== "undefined") {
                if (data.repeat) {
                    //TODO: resource for repeat/wiederholend
                    rangeText += " " + "(" + this.resources[this.lang].label.holidayYearly + ")";
                }
            }
            range.append($("<p>").addClass("range").html(rangeText));
            item.append(range, description);

            html.append(item);

            return html;
        },
        _openFromToPopup: function (edit, data, descriptionData) {
            var me = this;

            var container = $("<div>").addClass("_temp-vc-date-container");
            var el = null;
            var elHeader = $("<div>").addClass("popup-header").html(this.resources[this.lang].button.firstPage + ": ");
            var elDescription = $("<div>").addClass("_temp-vc-date-description").append(
                $("<div>").html(this.resources[this.lang].rangeDescription),
                $("<textarea>")
            );

            if (typeof data !== 'undefined') {
                el = $("<div>").vcDate({ mode: "Range", align: "center", defaultRange: data, interval: 1, langID: this.options.langID, callback: function() { } });
            } else {
                el = $("<div>").vcDate({ mode: "Range", align: "center", interval: 1, langID: this.options.langID, callback: function()  { } });
            }
            if (typeof descriptionData !== 'undefined') {
                elDescription.find("textarea").val(descriptionData);
            }

            el.find(".ul-dropdown #li-range .div-buttoncustomrange").remove();
            el.find(".div-PickRangeEnd").css("margin-left", "75px");
            el.data("edit", edit);
            el.addClass("_temp vc-calendar-filter");
            el.find(".div-widget").hide();
            el.find(".ul-dropdown").show();

            container.append(
                elDescription,
                elHeader,
                el
            );

            container.dialog({
                title: this.resources[this.lang].rangePopupTitle,
                modal: true,
                width: 612,
                height: 706,
                resizable: false,
                closeOnEscape: false,
                buttons: [
                    {
                        text: this.resources[this.lang].button.abort,
                        click: function () {
                            $(this).remove();
                        }
                    },
                    {
                        text: this.resources[this.lang].button.save,
                        click: function () {
                            var vcDateContainer = $(this).closest("._temp-vc-date-container");
                            var vcDate = vcDateContainer.find(".vc-date");

                            var vcDateData = {
                                range: [vcDate.find("input.input-StartRange").val(), vcDate.find("input.input-EndRange").val()]
                            }

                            var description = vcDateContainer.find("._temp-vc-date-description textarea");

                            var el = me._getFromToListItem(vcDateData, description.val());

                            if (vcDate.data("edit")) {
                                me.element.find(".from-to .from-to-content .from-to-list-item").each(function () {
                                    if ($(this).data("edit")) $(this).replaceWith(el);
                                });
                            } else {
                                me.element.find(".from-to-content").append(el);
                            }

                            me._sortFromToList();

                            vcDateContainer.remove();

                            $(this).remove();

                            me.options.callback();
                        }
                    }
                ],
                create: function () {
                    $(this).closest(".ui-dialog")
                        .find(".ui-button:nth-child(1)") // the first button
                        .addClass("abort");
                    $(this).closest(".ui-dialog")
                        .find(".ui-button:nth-child(2)") // the second button
                        .addClass("save");
                },
                dialogClass: 'saveDialog'
            });

            var dialogStyle = container.closest(".ui-dialog").attr("style");
            var dialogOverlayStyle = $("body").find("div.ui-widget-overlay.ui-front").attr("style");
            var zIndex = this._getHighestZIndex();

            $("body").find("div.ui-widget-overlay.ui-front").attr("style", dialogOverlayStyle + " z-index: " + (zIndex + 1) + " !important;");

            container.closest("div.ui-dialog").attr("style", dialogStyle + " z-index: " + (zIndex + 2) + " !important;");
        },
        _fillHolidayContent: function() {
            var me = this;
            var newHeight = -1;
            //

            if (me.element.find(".checkbox-holiday").prop("checked")) {
                newHeight = me.element.find(".from-to .from-to-content").height() - 50;
                window.VisualCoreService.getGlobalAlarmExceptions(function (result) {
                    var row = {}
                    if (me.element.find(".from-to .holiday-content").html() === "") {
                        result.rows.forEach(function(obj) {
                            row = {};
                            row.range = [obj.from, obj.to];
                            row.repeat = obj.repeat;
                            me.element.find(".from-to .holiday-content").append(me._getHolidayListItem(row));
                        });
                    }
                });
                me.element.find(".from-to .from-to-content").height(newHeight);
                me.element.find(".from-to .holiday-content").height(50);
            } else {
                var oldHeight = me.element.find(".from-to .from-to-content").height() + me.element.find(".from-to .holiday-content").height();
                me.element.find(".from-to .from-to-content").height(oldHeight);
                me.element.find(".from-to .holiday-content").height(0);
            }
        },
        _sortFromToList: function () {
            var me = this;

            var fromToContent = this.element.find(".from-to-content");

            var item = null;
            var itemList = fromToContent.find(".from-to-list-item");
            var itemListData = [];

            var fromToData = null;
            var descriptionData = null;

            itemList.each(function () {

                fromToData = $(this).find(".range").html().split(" - ");

                descriptionData = $(this).find(".from-to-list-item-description").html();

                item = {
                    range: [ fromToData[0], fromToData[1] ],
                    description: descriptionData
                }

                itemListData.push(item);
            });

            itemListData.sort(function (a, b) {
                // ReSharper disable once UseOfImplicitGlobalInFunctionScope
                return moment(a.range.from, "DD.MM.YYYY") - moment(b.range.from, "DD.MM.YYYY");
            });

            fromToContent.html("");

            itemListData.forEach(function (el) {
                fromToContent.append(
                    me._getFromToListItem(el, el.description)
                );
            });


        },

        _getHighestZIndex: function () {
            var z = 0;
            $("body *").each(function () {
                if ($(this).css("z-index") > z && $(this).css("z-index") !== "auto")
                    z = $(this).css("z-index");
            });
            return parseInt(z);
        },

        _setGlobals: function () {
            // ReSharper disable once AssignedValueIsNeverUsed
            var i = 0;

           
            this.lang = window.getLanguageShortcut(this.options.langID);
           

            /*this.options.langID++;
            if (this.options.langID < 1 || this.options.langID > 3) this.lang = "de";
            else this.lang = Object.keys($.datepicker.regional)[this.options.langID];
            */

            this.data.ID = this.element.attr("id");

            //set Months
            this.resources["months"].short = $.datepicker.regional[this.lang].monthNamesShort;
            this.resources["months"].long = $.datepicker.regional[this.lang].monthNames;

            //set Days
            var daysShort = $.datepicker.regional[this.lang].dayNamesShort;
            var daysLong = $.datepicker.regional[this.lang].dayNames;

            daysShort.push(daysShort[0]);
            daysLong.push(daysLong[0]);

            this.resources["weekDays"].long = [];
            this.resources["weekDays"].short = [];

            for (i = 1; i < daysShort.length; i++) this.resources["weekDays"].short.push(daysShort[i]);
            for (i = 1; i < daysLong.length; i++) this.resources["weekDays"].long.push(daysLong[i]);

        },

        _setOptions: function () {
            var me = this;

            if (this.options.type === "popup") {
                switch (this.options.align) {
                    case "left":
                        this.element.find(".container").addClass("vc-calendar-filter-left");
                        break;
                    case "center":
                        this.element.find(".container").addClass("vc-calendar-filter-center");
                        break;
                    case "right":
                        this.element.find(".container").addClass("vc-calendar-filter-right");
                        break;
                    default:
                        this.element.find(".container").addClass("vc-calendar-filter-right");
                        break;
                }
            }

            this.element.find(".time .timer").html(this.options.data["Timer"]);

            this.element.find(".time .timer").vcClockTimer({width:554});

            this.element.find(".time .clocktimer").addClass("vc-grid-margin-top");
            //this.element.find(".time .clocktimer").addClass("vc-grid-margin-top vc-grid-margin-bottom");

            this.element.find(".page").hide();
            this.element.find(".first-page").show();

            this.element.find(".container")
                //.height(this.options.height)
                .width(this.options.width);

            this.element.find(".period .month-input .checkbox").each(function (i) {
                if (me.options.data["Months"][i] === 1) $(this).attr("checked", true);
            });

            this.element.find(".period .week-input .checkbox").each(function (i) {
                if (me.options.data["WeekDays"][i] === 1) $(this).attr("checked", true);
            });

            this.options.data["FromTo"].forEach(function (el) {
                var data = {
                    range: [el.range[0], el.range[1]] 
                };
                var listItem = me._getFromToListItem(data, el.description);
                //listItem.find(".from-to-list-item-description").html(el.description);

                me.element.find("div.from-to-content").append(listItem);
            });
            this._sortFromToList();

            if (me.options.data["Holidays"]) {
                this.element.find(".from-to .checkbox-holiday").attr("checked", true);
                me._fillHolidayContent();
            }

            if (me.options.data["WeekDays"].length !== 7) this.element.find(".week input[type='checkbox']").attr("checked", true);
            if (me.options.data["Months"].length !== 12) this.element.find(".month input[type='checkbox']").attr("checked", true);
        },

        _setData: function () {
            var me = this;

            var months = $(this.element.find(".period .month .checkbox"));
            var week = $(this.element.find(".period .week .checkbox"));
            var timer = $(this.element.find(".time .timer"));
            var fromTo = $(this.element.find(".from-to-list-item"));

            this.data.ID = this.element.attr("id");

            months.each(function (i) {
                if ($(this).prop("checked")) me.data["Months"][i] = 1;
                else me.data["Months"][i] = 0;
            });

            week.each(function (i) {
                if ($(this).prop("checked")) me.data["WeekDays"][i] = 1;
                else me.data["WeekDays"][i] = 0;
            });
            
            this.data.Timer = timer.html();

            this.data["FromTo"] = [];
            fromTo.each(function () {
                var fromToRange = $(this).find(".from-to-list-item-data .range");
                var fromToText = $(this).find(".from-to-list-item-description");

                var rangeData = fromToRange.html().split(" - ");
                var descriptionText = fromToText.html();

                me.data["FromTo"].push({ range: rangeData, description: descriptionText });
            });

            //if (this.element.find(".from-to .checkbox-holiday").prop("checked")) {
            //    this.data["Holidays"] = true;
            //}

            this.data["Holidays"] = this.element.find(".from-to .checkbox-holiday").prop("checked");
            
        },

        getData: function () {
            this._setData();
            return this.data;
        }

    });